export default __webpack_public_path__ + "static/media/bpld-logo.c938cc6a.png";